import { MACARON_INLINE_ICONS, type MacaronInlineIconComponent } from './macaronInlineIcons';

export type MacaronIconStyle = 'line' | 'filled';

export function resolveMacaronCanonicalIconName(name: string | null | undefined) {
  if (!name) return undefined;
  return name.trim().toLowerCase() || undefined;
}

export function resolveMacaronIconComponent(name: string | null | undefined, style: MacaronIconStyle = 'line'): { canonicalName: string; Component: MacaronInlineIconComponent } | undefined {
  const canonicalName = resolveMacaronCanonicalIconName(name);
  if (!canonicalName) return undefined;
  const iconDefinition = MACARON_INLINE_ICONS[canonicalName];
  if (!iconDefinition) return undefined;
  const Component = style === 'filled' ? iconDefinition.filled || iconDefinition.line : iconDefinition.line;
  return { canonicalName, Component };
}
